module.exports = __webpack_public_path__ + "img/1.31779ce1.gif";